<template>
<div class="panel-body">
   <button :disabled="loading" @click="consultaSaldo()" class="btn btn-default"><i class="fa fa-search"></i>Consultar</button> 
   <h3 class="text-center">Saldo API: {{response.saldo_api}} / Saldo Total Vendido: {{response.saldo_vendido.saldoTotalVendido}} / Disponível para venda: {{response.saldo_api - response.saldo_vendido.saldoTotalVendido}} </h3>
   <table class="table table-sm table-hover table-bordered table-condensed">
      <thead>
          <tr>
              <th>Empresa</th>
              <th>Saldo</th>
          </tr>
      </thead>
      <tbody>
          <tr v-for="(item, i) in response.saldo_vendido.empresas" :key="i">
              <td>{{item.empresa}}</td>
              <td>{{item.saldo}}</td>
          </tr>
      </tbody>
   </table>
</div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            response: {
                saldo_api: 0,
                saldo_vendido: {
                    saldoTotalVendido: 0,
                    empresas: []
                }
            }
        }
    },
    methods: {
        consultaSaldo() {
            this.loading = true;
            this.$store.dispatch('getApiSmsBalance').then(response => {
                this.response = response;
            }).catch(error => {
                console.log(error);
            }).finally(f => {
                this.loading = false;
            });
        }
    }
    
}
</script>